import { type MessageArgsProps, message } from 'antd';

export const showMessage = (props: MessageArgsProps) => {
  message.open({
    duration: 2,
    ...props,
  });
};
